import { ApplicationState, AppThunkAction, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import UserForm  from "../../components/Forms/UserForm";
import { getMyUser } from "../../store/session/selectors";
import { PermissionEnum } from "../../models";
import { UserEntity } from "../../store/entities/state";
import { isSubmitting, getChangeLog, getChangingValue, getChangingState } from "../../store/entities/selectors";
import { entityEditionCancel, updateEntity, loadEntityChangeLog, updateChangingEntity, deleteEntity } from "../../store/entities/actions";
import { updateUserAsync, sendConfirmationEmailForUserAsync, getUserChangeLogAsync, deleteUserAsync } from "../../ajax/requests";
import { UserFormData, UserFormDispatchProps, UserFormStateProps } from "../../components/Forms/UserForm/UserForm";
import { alertGenericError, alertSuccess } from "../../store/alerts/actions";
import { TK } from "../../store/translations/translationKeys";
import { translate } from "../../store/translations/hooks";

const canEdit = (state: ApplicationState) => getMyUser(state)?.permissions.includes(PermissionEnum.Administrator) || false;

export interface UserFormProps {
    data: UserEntity,
    onClose?: () => void,
}

const sendConfirmationEmail = (userId: string): AppThunkAction<Promise<void>>  => {
    return async (dispatch, getState) => {
        try {
            await sendConfirmationEmailForUserAsync(userId);
            dispatch(alertSuccess(translate(TK.confirmationEmailSent)));
        } catch(error) {
            dispatch(alertGenericError());
        }
    }
}

const mapStateToProps = (state: ApplicationState, ownProps: UserFormProps): UserFormStateProps => ({
    type: 'edit',
    canEdit: canEdit(state),
    data: getChangingValue(state, 'users') as UserFormData || ownProps.data,
    hasChanged: getChangingState(state, 'users'),
    isSubmitting: isSubmitting('users')(state),
    changeLog: getChangeLog(state, 'users', ownProps.data.id),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch, ownProps: UserFormProps): UserFormDispatchProps => ({
    onChange: (data: UserFormData) => dispatch(updateChangingEntity('users', data)),
    onCancel: () => {
        dispatch(entityEditionCancel('users'));
        ownProps.onClose && ownProps.onClose();
    },
    onSave: (data: UserEntity) => {
        return dispatch(updateEntity('users', data, c => updateUserAsync(c.id, c)))
            .then(_ => {
                // Only close if update was successful
                ownProps.onClose && ownProps.onClose();
            })
            .catch(error => {
                // Error is already handled by updateEntity action, just prevent closing
                console.error('Failed to update user:', error);
            });
    },
    onDelete: () => {
        dispatch(deleteEntity('users', ownProps.data.id, () => deleteUserAsync(ownProps.data.id)))
            .then(_ => {
                ownProps.onClose && ownProps.onClose();
            })
            .catch(error => {
                console.error('Failed to delete user:', error);
            });
    },
    onSendConfirmationEmail: () => {
        dispatch(sendConfirmationEmail(ownProps.data.id));
    },
    onLoad: () => {
        dispatch(loadEntityChangeLog('users', ownProps.data.id, () => getUserChangeLogAsync(ownProps.data.id)));
    },
});

export default connect<UserFormStateProps, UserFormDispatchProps, UserFormProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(UserForm as any);
